import type { RewardItem } from './reward'

export interface User {
  user: {
    id: number
    name: string | null
    email: string
  }
}

export interface Prize {
  id: number
  name: string
  executed: boolean
  hidden: boolean
  featured?: boolean
  media_id: number
  media: any
  prize_rules: PrizeRule[]
  // O Parceiro que patrocina o concurso. Sob a regra `partner_checkin` e ele
  // que define quem concorre, e o nome que a regra mostra ao Participante.
  partner?: { id: number; name?: string } | null
  winner_progress_id?: number | null
  winner_progress: {
    user: User | null
  }
}

export enum PrizeRulesKindsEnum {
  VOUCHER_BUYERS = 'voucher_buyers',
  GUILD_TOP = 'guild_top',
  EVENT_TOP = 'event_top',
  EVENT_PARTICIPANTS = 'event_participants',
  MISSION = 'mission',
  PARTNER_CHECKIN = 'partner_checkin'
}

export interface PrizeRulable {
  id: number
  uid: string
  reward_id: number
  reward?: RewardItem | null
  reward_category_id: number | null
  name: string
  description: string | null
  image_id: string | null
  coin: number | null
  min_quantity: number | null
  max_quantity: number | null
  quantity: number | null
  quantity_sold: number
  active: boolean
}

export interface PrizeRule {
  id: number
  kind: PrizeRulesKindsEnum
  limit: number
  prize_id?: number
  prize_rulable: PrizeRulable
}
